import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const ChartOfAccountsListDetails = () => { 
  const [chartOfAccounts, setChartOfAccounts] = useState([]); 
  
  useEffect(() => { 
            
    fetchChartOfAccounts(); 
  }, []); 
  
  const fetchChartOfAccounts = async () => { 
    try { 
      const url = `${API_DOMAIN}${API_ROUTES.chart_of_account}`; 
      const token = localStorage.getItem('token'); 
       
      const response = await axios.get(url, { headers }); 
      const chartOfAccountsData = response.data.map((account) => {
        return { 
          ...account, 
          account_type_name: account.account_type === "ASSET" ? "Asset" : 
                             account.account_type === "LIABILITY" ? "Liability" : 
                             account.account_type === "EQUITY" ? "Equity" : 
                             account.account_type === "REVENUE" ? "Revenue" : 
                             account.account_type === "EXPENSE" ? "Expense" : "", 
        };
      });
      setChartOfAccounts(chartOfAccountsData); 
    } catch (error) { 
      console.error('Error fetching chart of accounts:', error); 
    } 
  };

  const columns = [ 
    { label: 'Account Code', value: 'code' }, 
    { label: 'Account Name', value: 'name' }, 
    { label: 'Account Type', value: 'account_type_name' }, 
    { label: 'Parent Account', value: 'parent_account' }, 
    { label: 'Balance', value: 'balance' }, 
    { label: 'Currency', value: 'currency' }, 
  ]; 

  const handleViewDetails = (accountId) => { 
    //console.log('View Details', accountId); 
    window.location.href = `/chart-of-accounts/details/${accountId}`; 
  }; 

  const handleEditDetails = (accountId) => {
    window.location.href = `/chart-of-accounts/input/${accountId}`;
  };

  const actionButtons = [ 
    { label: 'Edit Details', handler: handleEditDetails }, 
  ]; 

  return <ListTemplate columns={columns} data={chartOfAccounts} actionButtons={actionButtons} />; 
}; 

export default ChartOfAccountsListDetails;